import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import TableHeadSort from "@/Shared/TableHeadSort";
import Pagination from "@/Shared/Pagination";
import parseNetworkIds from "@/Assets/parseNetworkIds";
import PublicMerchantActionBtns from "@/Pages/Merchants/Assets/PublicMerchantActionBtns";
import PaginateCount from "@/Shared/PaginateCount";
import PublicMerchantsSearchFilter from "@/Pages/Merchants/Assets/PublicMerchantsSearchFilter";
import useCheckbox from '@/Hooks/useCheckbox';
import PublicMerchantsBottomPanel from '@/Pages/Merchants/Assets/PublicMerchantsBottomPanel';

const Index = () => {
  const {merchants} = usePage().props;

  const {
    data,
    meta: {links}
  } = merchants;

  const {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  } = useCheckbox(data, 'merchant_id')

  return (
    <div>
      <div className='mb-3 flex justify-between items-center	'>
        <h1 className="text-3xl font-bold">Published Merchants</h1>
      </div>
      <div className="flex items-center justify-between mb-6">
        <PublicMerchantsSearchFilter/>

        <PaginateCount/>
      </div>
      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="w-full table-auto text-sm">
          <thead>
          <tr className="font-bold text-left">
            <th className="px-1 pt-5 pb-4 w-10">_</th>
            <th className="px-1 pt-5 pb-4 w-12">Logo</th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 text-center w-20' sortName='merchant_id' title='ID'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='merchant_name' title='Merchant Name (# coupons)'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='relative_uri' title='Relative URL'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='intNetworkID' title='Network'/>
            <th className="px-1 pt-5 pb-4 w-56">Actions</th>
          </tr>
          </thead>
          <PublicMerchantsBottomPanel checked={checked} handleCheckAll={handleCheckAll} parentCheckbox={parentCheckbox}/>
          <tbody ref={checkboxesParent}>
          {merchants.data.map(({
                                 merchant_name,
                                 relative_uri,
                                 merchant_id,
                                 def_image_logo,
                                 merchant_link_url,
                                 coupons_count,
                                 showonline,
                                 isLive,
                                 intNetworkID
                               }) => (
            <tr
              key={merchant_id}
              className="hover:bg-gray-100 focus-within:bg-gray-100"
            >
              <td className="border-t">
                <div className="flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none">
                  <input
                    type="checkbox"
                    name={merchant_id}
                    onChange={handleCheck} />
                </div>
              </td>
              <td className="border-t">
                <InertiaLink
                  href={route('added.merchants.edit', merchant_id)}
                  className="flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none"
                >
                  {def_image_logo && (
                    <img
                      src={def_image_logo}
                      className="block w-10 h-5 mr-2 -my-2"
                    />
                  )}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center justify-center px-1 py-4 focus:text-indigo focus:outline-none text-center"
                  href={route('added.merchants.edit', merchant_id)}
                >
                  {merchant_id}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                  href={route('added.merchants.edit', merchant_id)}
                >
                  {merchant_name} ({coupons_count})
                </InertiaLink>
              </td>
              <td className="border-t">
                <a
                  target="_blank"
                  className="flex items-center px-1 py-4  hover:text-orange-600 text-indigo-700 underline"
                  href={'https://www.couponola.com/stores/' + relative_uri}
                >
                  {relative_uri}
                </a>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                  href={route('added.merchants.edit', merchant_id)}
                >
                  {parseNetworkIds(intNetworkID)}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <PublicMerchantActionBtns showonline={showonline} link={merchant_link_url} id={merchant_id}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className="px-1 py-4 border-t" colSpan="4">
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links}/>
    </div>
  );
};

Index.layout = page => <Layout title="Published Merchants" children={page}/>;

export default Index;
